import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    AbstractPageComponent,
    FoehnBooleanRadioComponent,
    SdkDictionaryService,
    SessionInfoData,
    SessionInfoWithApplicationService
} from '@dsivd/prestations-ng';
import { Subscription } from 'rxjs';

import { BusinessForm } from '../../model/business-form';
import { CadorReference } from '../../model/cador-reference';
import { LibelleConfigurable } from '../../model/libelle-configurable';
import { Personne } from '../../model/personne';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';
import { ElementUtils } from '../../utils/element.utils';

@Component({
    templateUrl: './request-origin-page.component.html'
})
export class RequestOriginPageComponent extends AbstractPageComponent<BusinessForm> implements OnInit, AfterViewInit {

    @ViewChild('foehnBooleanRadioIsSelfRequest')
        foehnBooleanRadioIsSelfRequest: FoehnBooleanRadioComponent;

    @ViewChild('foehnBooleanRadioIsResidentVaud')
        foehnBooleanRadioIsResidentVaud: FoehnBooleanRadioComponent;

    wholeValue = ElementUtils.wholeValue;

    initiators: CadorReference[];
    situations: CadorReference[];
    libelles: LibelleConfigurable[];
    personne: Personne;
    isBenefitRecipient = false;
    isResidentCanton = null;

    private booleanRadioIsSelfRequestSubscription: Subscription;
    private booleanRadioIsNonResidentSubscription: Subscription;

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        private refCadorService: RefCadorService,
        private sessionInfoWithApplicationService: SessionInfoWithApplicationService
    ) {
        super(activatedRoute);

        this.sessionInfoWithApplicationService.prefillForm((info: SessionInfoData) => {
            this.form.requestOrigin.firstName = info.firstName;
            this.form.requestOrigin.lastName = info.lastName;

            if (info.preferences) {
                this.form.requestOrigin.email = info.preferences.email;
                this.form.requestOrigin.phone = info.preferences.phone;
            }
        });

        this.initiators = this.refCadorService.getInitiatorsSync();
        this.libelles = this.refCadorService.getLibellesSync();
        this.situations = this.refCadorService.getSituationsSync();
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('request-origin.title'));
    }

    getRenderHTML(): any {
        const libelle = this.libelles.find(value => value.valeur === this.form.requestOrigin.libelleConfigurable.valeur);

        if (libelle) {
            return libelle.libelleEtape1;
        } else {
            return '';
        }
    }

    getMessageNonResident(): any {
        const libelle = this.libelles.find(value => value.valeur === RefCadorService.CADOR_CODE_NON_RESIDENT_CANTON);

        if (libelle) {
            return libelle.libelleEtape1;
        } else {
            return '';
        }
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }

    send(goToNextPage?: boolean): void {
        this.beforeSend();
        super.send(goToNextPage);
    }

    ngAfterViewInit(): void {
        super.ngAfterViewInit();

        this.booleanRadioIsSelfRequestSubscription = this.foehnBooleanRadioIsSelfRequest.modelChange
            .subscribe((model: boolean) => {

                this.isBenefitRecipient = model === null || typeof model === 'undefined' ? false : model.valueOf();

                if (this.isBenefitRecipient) {
                    this.form.requestOrigin.initiator = this.initiators.find(
                        value => value.valeur === RefCadorService.CADOR_CODE_CONTACT_BENEFICIAIRE);
                }
            });

        this.booleanRadioIsNonResidentSubscription = this.foehnBooleanRadioIsResidentVaud.modelChange
            .subscribe((model: boolean) => {

                this.isResidentCanton = model === null || typeof model === 'undefined' ? false : model.valueOf();

            });
    }

    private beforeSend(): void {
        if (this.form.requestOrigin.libelleConfigurable) {
            this.form.requestOrigin.situation = this.situations
                .find(value => value.valeur === this.form.requestOrigin.libelleConfigurable.valeur);
        }

        if (this.form.requestOrigin.isSelfRequest) {
            this.form.informationApplicant.lastName = this.form.requestOrigin.lastName;
            this.form.informationApplicant.firstName = this.form.requestOrigin.firstName;
            this.form.informationApplicant.email = this.form.requestOrigin.email;
            this.form.informationApplicant.phone = this.form.requestOrigin.phone;
        }

        if (this.form.personnesReference.personnesReferences.length > 0) {
            // c'est le demandeur
            this.personne = this.form.personnesReference.personnesReferences[0];
        } else {
            // ajout le demandant en tant que personne de référence
            this.personne = new Personne();
            this.personne.internalReference = Math.random().toString(36).substring(2, 5);
            this.form.personnesReference.personnesReferences.push(this.personne);
        }
        // recopie des infos du demandeur dans celles de la personne de référence
        this.personne.role = this.form.requestOrigin.initiator;
        this.personne.prenom = this.form.requestOrigin.firstName;
        this.personne.nom = this.form.requestOrigin.lastName;
        this.personne.email = this.form.requestOrigin.email;
        this.personne.telephone = this.form.requestOrigin.phone;
        // et on indique que celle-ci est bien le demandeur
        this.personne.isDemandeur = true;

    }
}
